import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { deleteToken, getToken } from 'firebase/messaging';
import { firstValueFrom, take } from 'rxjs';
import { FirebaseService } from './firebase.service';
import { AuthSyncService } from './auth-sync.service';
import { UserService } from '../swagger';
// import { UserService } from 'src/swagger';

@Injectable({
  providedIn: 'root',
})
export class FcmService {
  public permissionStatus: 'default' | 'granted' | 'denied' = 'default';

  constructor(
    readonly firebase: FirebaseService,
    readonly authSync: AuthSyncService,
    readonly userService: UserService
  ) {
    try {
      this.permissionStatus = window.Notification.permission;
      if (this.permissionStatus === 'granted') {
        this.refreshToken();
      }
    } catch (ignore) {
      console.log(ignore);
    }
  }

  // await auth token init then refresh fcm token
  private refreshToken() {
    this.authSync.$user.pipe(take(1)).subscribe(async user => {
      if (user) {
        getToken(this.firebase.fire_messaging, { vapidKey: environment.vapidKey })
          .then(async currentToken => {
            if (currentToken) {
              this.permissionStatus = 'granted';
              console.log('WebPushToken Received');
              await firstValueFrom(
                this.userService.setFcmToken({
                  token: currentToken,
                })
              );
              localStorage.setItem('isPushedNotificationEnabled', 'true');
            } else {
              this.permissionStatus = 'denied';
              console.log('No registration token available. Request permission to generate one.');
            }
          })
          .catch(err => {
            this.permissionStatus = 'denied';
            console.log('An error occurred while retrieving token. ', err);
          });
      }
    });
  }

  async requestWebPermissions() {
    await window.Notification.requestPermission()
      .then(permission => {
        if (permission === 'granted') {
          this.refreshToken();
        }
      })
      .catch(err => {
        console.error(err);
      });
  }

  async deleteWebPermissions() {
    const messaging = this.firebase.fire_messaging;
    const currentToken = await getToken(messaging, {
      vapidKey: environment.vapidKey,
    });
    if (currentToken) {
      const deleted = await deleteToken(messaging);
      if (deleted) {
        console.log('FCM token deleted from browser');
        await firstValueFrom(this.userService.removeFcmToken());
        localStorage.removeItem('isPushedNotificationEnabled');
      }
    } else {
      console.warn('No FCM token found.');
    }
  }
}
